import { render } from "./KpsInspectionsView.vue?vue&type=template&id=e0ecfece&scoped=true"
import script from "./KpsInspectionsView.vue?vue&type=script&lang=js"
export * from "./KpsInspectionsView.vue?vue&type=script&lang=js"

import "./KpsInspectionsView.vue?vue&type=style&index=0&id=e0ecfece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ecfece"]])

export default __exports__